import {Inject, Injectable} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {ApiService} from './api.service';
import {ToastrService} from "ngx-toastr";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {CookieService} from "ngx-cookie-service";
import {NgxIndexedDBService} from "ngx-indexed-db";



@Injectable({
  providedIn: 'root'
})
export class InternalService {

  constructor(private cookieService: CookieService,
              public translate: TranslateService,
              private dbService: NgxIndexedDBService,
              public apiService: ApiService,
              public toastr: ToastrService,) {
  }


  async getMd5(image) {
    const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
    if (result == undefined) {
// ---------------------check number of rows in a store-----------------------
      this.dbService.count('Images').subscribe((count) => {
        // console.log('count', count);
        if (count > 100) {
          this.dbService.clear('Images').subscribe((successDeleted) => {
            // console.log('success? ', successDeleted);
          });
        }
      });
// ----------------------------------insert store-----------------------------
      const response = await this.apiService.apiCall('get', '/api/image/GetImage/' + image, {}).toPromise();
      this.dbService
        .add('Images', {
          MD5: image,
          icon: response['res']['imageFormat'] + response['res']['imageString'],
        })
      return response['res']['imageFormat'] + response['res']['imageString']
    } else {
      return result.icon
    }
  }

  changeLang(language: string, id) {
    if (language === 'fa-ir') {
      this.cookieService.set('lang', '1');
    } else {
      this.cookieService.set('lang', '2');
    }
    // the methode for change lang and direction of whole website
    this.translate.use(language);
    this.translate.get('dir', language).subscribe(
      (res) => {

        this.apiService.currentDirection = res;

        const dom: any = document.querySelector('body');

        if (res === 'rtl' && !dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 1);
          dom.classList.toggle('rtl');

          if (id !== 0) {
            window.location.reload();
          }
        }
        if (res === 'ltr' && dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 2);
          dom.classList.toggle('rtl');
          if (id !== 0) {
            window.location.reload();
          }

        }
      }
    );
  }




  showSuccess(message, title) {
    this.toastr.success(message, title);
  }

  showError(message, title) {
    this.toastr.error(message, title);
  }

}
